import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import { useFollow } from '../hooks/useFollow';

export interface FollowButtonProps {
  userId: string;
  initialIsFollowing?: boolean;
  onFollowChange?: (isFollowing: boolean) => void;
}

/**
 * Follow/Unfollow button that toggles the follow state for a given user.
 */
export function FollowButton({ userId, initialIsFollowing = false, onFollowChange }: FollowButtonProps) {
  const { isFollowing, isLoading, toggle } = useFollow(userId, initialIsFollowing);

  const handleClick = async () => {
    await toggle();
    onFollowChange?.(!isFollowing);
  };

  return (
    <Button
      variant={isFollowing ? 'outlined' : 'contained'}
      color={isFollowing ? 'inherit' : 'primary'}
      size="small"
      disabled={isLoading}
      startIcon={
        isLoading ? (
          <CircularProgress size={16} />
        ) : isFollowing ? (
          <PersonRemoveIcon />
        ) : (
          <PersonAddIcon />
        )
      }
      onClick={handleClick}
      aria-label={isFollowing ? 'Unfollow user' : 'Follow user'}
    >
      {isFollowing ? 'Following' : 'Follow'}
    </Button>
  );
}
